import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewContractService {
  products: any;
  productsCosts: any;
  totalProductsCosts : any ;
  purchasesSummary : any;
  // get all customers contract to put on email popup in cancellation page
  customerList:BehaviorSubject<any> = new BehaviorSubject<any>([]);
  hasCancellationBefore:boolean = false;
  constructor() { }
  public backForEditing : boolean = false ;
  public fromNewContract : boolean = false ;
  public returningFromCustomerInfo : boolean = false ;
  private newVehicleSubject = new BehaviorSubject<any>(null)
  public returningFromSummary  : boolean = false
  public lienholderState : boolean = false ;
  public isEditingContract : boolean = false ;
  public contractId : number|null =  null
  public contractOnEdit : any
  setNewVehicleData(data:{}){
    this.newVehicleSubject.next(data)
  }

  getNewVehicleData(){
    return this.newVehicleSubject.value
  }

  getVehicleInformation(){
    let x: any = localStorage.getItem('vehicle_information')
    if(x)
      return JSON.parse(x)
    else
      return null
  }

  setVehicleInformation(vehicleData : {}){
      localStorage.setItem('vehicle_information' ,JSON.stringify(vehicleData) )
  }

  getCustomerInformation(){
    let x: any = localStorage.getItem('customer_information')
    if(x)
      return JSON.parse(x)
    else
      return null
  }
  getCustomerInformation2(){
    let x: any = localStorage.getItem('customer_information2')
    if(x)
      return JSON.parse(x)
    else
      return null
  }
  setCustomerInformation(customerInformation: any,customerInformation2?: any){
    localStorage.setItem('customer_information',JSON.stringify(customerInformation))
    if(customerInformation2)
      localStorage.setItem('customer_information2',JSON.stringify(customerInformation2))
  }
  getProductInformation(){
    let x: any = localStorage.getItem('product_information')
    if(x)
      return JSON.parse(x)
    else
      return null
  }
  setProductInformation(productInformation: any){
    localStorage.setItem('product_information',JSON.stringify(productInformation))
  }
  setProducts(products:any){
    localStorage.setItem('products_information',JSON.stringify(products))
  }
  getProducts(){
    let x: any = localStorage.getItem('products_information')
    if(x)
      return JSON.parse(x)
    else
      return null
  }
  setProductsCosts(costs:any){
    localStorage.setItem('products_costs',JSON.stringify(costs))
    this.productsCosts = costs
  }
  getProductsCosts(){
    let x: any = localStorage.getItem('products_costs')
    if(x)
      return JSON.parse(x)
    else
      return null

  }

  removeAll(){
    localStorage.removeItem('product_information')
    localStorage.removeItem('customer_information2')
    localStorage.removeItem('customer_information')
    localStorage.removeItem('vehicle_information')
    localStorage.removeItem('products_information')
    localStorage.removeItem('products_costs')
  }
}

